import React from 'react'
import './App.css'
import TermsnConditions from './TermsnConditions';


class AppTermsAndConditions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            tc: true,
            operatorName: this.props.operatorName ? this.props.operatorName : this.props.match.params.operator
        }
    }

    async componentDidMount() {
        // api call for data
    }
    FaqPressed() {
        var current = this.state.faq;
        this.setState({
            faq: !current
        })
    }
    MasterBlasterPressed() {
        var current = this.state.mbp;
        this.setState({
            mbp: !current
        })
    }
    GameRulesPressed() {
        var current = this.state.gr;
        this.setState({
            gr: !current
        })
    }
    TCPressed() {
        var current = this.state.tc;
        this.setState({
            tc: !current
        })
    }

    render() {

        return (
            <div id='main-section' style={{ backgroundColor: '#E5E5E5', zIndex: '0' }}>
                {
                        <div className='card'>
                            <div className="row" style={{ 'fontSize': '16px', "fontWeight": 'normal' }}>
                                <div className="col-12 text-center">
                                  
                                    {/* TERMS & CONDITIONS */}
                                    <div className="mt-3 mb-3">
                                            <h2 className="ml-2 text-left" style={{ fontWeight: 'bold' }}>TERMS & CONDITIONS</h2>
                                            
                                        <hr className="m-0 mx-0" />
                                        <div>
                                            <div className="">
                                            <TermsnConditions operatorName={this.state.operatorName}></TermsnConditions>
                                        </div>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>

                }
            </div>
        );
    }
}

export default AppTermsAndConditions;